export const PERMISSION_SET_SELECT_STYLE =
  'w-full max-w-[16rem] h-8 border border-grey-2 rounded-md text-sm leading-tight px-2 bg-white disabled:opacity-50 disabled:cursor-not-allowed';
